<template>
  <span v-if="hasUrlFile"
        class="layout-file-preview"
        :class="{'is-bold': bold}">
    <el-link v-if="url"
             type="primary"
             :href="$contextPath(url)"
             :underline="false"
             target="_blank">
      <span>{{downloadText}}</span>
      <i class="iconfont icon-xiazai"></i>
    </el-link>
    <el-link v-if="previewUrl"
             type="primary"
             :href="$contextPath(previewUrl)"
             :underline="false"
             target="_blank">
      <span>{{previewText}}</span>
      <i class="el-icon-data-board"></i>
    </el-link>
  </span>
</template>

<script>
export default {
  name: 'FilePreview',
  props: {
    url: String,
    previewUrl: String,
    downloadText: {
      type: String,
      default: '下载'
    },
    previewText: {
      type: String,
      default: '预览'
    },
    bold: Boolean
  },
  computed: {
    hasUrlFile () {
      return !!this.url || !!this.previewUrl
    }
  }
}
</script>

<style lang="scss">
  .layout-file-preview {
    display: inline-flex;
    align-items: center;
    &.is-bold {
      & > .el-link {
        & > .el-link--inner {
          span {
            font-weight: bold;
          }
        }
      }
    }
    & > .el-link {
      & > .el-link--inner {
        font-size: 12px;
        i {
          min-width: 20px!important;
          font-size: 14px;
          text-align: center;
          position: relative;
          top: 1px;
        }
      }
      & + .el-link {
        margin-left: 16px;
        position: relative;
        &:before {
          content: '';
          position: absolute;
          left: -10px;
          top: 50%;
          width: 1px;
          height: 12px;
          margin-top: -6px;
          background-color: #dcdfe6;
        }
      }
    }
  }
</style>
